import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {
  CertGlobe,
  CertFamily,
  CertMoney,
} from '@lt/components/icons-react/gift_certificate';
import Feature from './Feature';
import withMobile from '../hocs/withMobile';
import { NBSP } from '../../../constants/common';

const commonIconStyles = css`
  ${(props) => (props.isMobile ? '--icon-size: 27px;' : '--icon-size: 46px;')}

  margin-right: 15px;
  width: var(--icon-size);
  height: var(--icon-size);
`;
const StyledGlobeIcon = styled(CertGlobe)`
  ${commonIconStyles}
`;

const StyledFamilyIcon = styled(CertFamily)`
  ${commonIconStyles}
`;

const StyledMoneyIcon = styled(CertMoney)`
  ${commonIconStyles}
`;

const FEATURES = [
  {
    name: 'cert-globe',
    Icon: StyledGlobeIcon,
    text: `Возможность выбрать любой тур в любую страну на${NBSP}сайте Level.Travel`,
  },
  {
    name: 'cert-family',
    Icon: StyledFamilyIcon,
    text: `Взять с собой сколько угодно детей, друзей и${NBSP}знакомых`,
  },
  {
    name: 'cert-money',
    Icon: StyledMoneyIcon,
    text: `Оплатить сертификатом стоимость тура целиком или${NBSP}частично`,
  },
];

const FeaturesList = ({ isMobile }) => (
  <FeaturesContainer isMobile={isMobile}>
    {FEATURES.map(({ name, text, Icon }, idx) => (
      <Feature key={name} number={idx + 1} Icon={Icon} isMobile={isMobile}>
        {text}
      </Feature>
    ))}
  </FeaturesContainer>
);

const FeaturesContainer = styled.div`
  margin-top: 25px;
  margin-bottom: 75px;
  display: flex;
  width: 100%;
  justify-content: space-between;

  ${(props) =>
    props.isMobile &&
    css`
      margin: 50px 0;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      ${Feature} {
        &:nth-child(odd) {
          margin-right: 90px;
        }

        &:nth-child(even) {
          margin-left: 90px;
        }
      }
    `};
`;

FeaturesList.propTypes = {
  isMobile: PropTypes.bool,
};

FeaturesList.defaultProps = {
  isMobile: false,
};

export default React.memo(withMobile(FeaturesList));
